import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@clerk/react';
import { Landing } from './pages/Landing';
import { SignInPage } from './pages/SignIn';
import { SignUpPage } from './pages/SignUp';
import { AppShell } from './components/AppShell';
import { Inbox } from './pages/Inbox';
import { Tools } from './pages/Tools';
import { Settings } from './pages/Settings';
import { Customers } from './pages/Customers';
import { Reports } from './pages/Reports';
import { Team } from './pages/Team';
import { NotFound } from './pages/NotFound';

/**
 * ProtectedRoute — hooks-based guard (clerk-react-patterns skill).
 * We intentionally don't use `<SignedIn>/<SignedOut>` wrappers because
 * the loaded state needs to resolve before we render OR redirect.
 */
function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) {
    return (
      <div
        role="status"
        aria-busy="true"
        className="min-h-screen grid place-items-center text-sm text-muted-foreground"
      >
        Loading…
      </div>
    );
  }
  if (!isSignedIn) return <Navigate to="/sign-in" replace />;
  return <Outlet />;
}

export function App() {
  return (
    <Routes>
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<AppShell />}>
          <Route index element={<Navigate to="inbox" replace />} />
          <Route path="inbox" element={<Inbox />} />
          <Route path="inbox/:ticketId" element={<Inbox />} />
          <Route path="customers" element={<Customers />} />
          <Route path="reports" element={<Reports />} />
          <Route path="tools" element={<Tools />} />
          <Route path="team" element={<Team />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Route>
      <Route path="/" element={<Landing />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
